// Generado por scripts/i18n_generar.py (inglés → español)
export const EN_ES = {
 "Container pending pickup": "Contenedor pendiente de recogida",
 "Pickup Chassis": "Recogida de chasis",
 "Empty Container Pickup": "Recogida de contenedor vacío",
 "Pickup Location": "Lugar de carga",
 "Return Loaded Container": "Devolución del contenedor cargado",
 "Location notes": "Notas de la ubicación",
 "Container photo": "Foto del contenedor",
 "Add container photo": "Agregar foto del contenedor",
 "Choose a photo": "Elegir una foto",
 "Upload a JPG or PNG container photo.": "Sube una foto del contenedor en JPG o PNG.",
 "Enter the container number you picked up.": "Escribe el número del contenedor que recogiste.",
 "Confirm loading and departure": "Confirmar carga y salida",
 "Confirm loaded return and departure": "Confirmar devolución del contenedor cargado y salida",
 "Reported container: {numero_contenedor}": "Contenedor reportado: {numero_contenedor}",
 "The driver reports the container at Empty Container Pickup.": "El chofer informa el contenedor al recoger el vacío.",
 "Yard stop is not part of the export route": "La parada en yarda no pertenece al recorrido de exportación",
 ". Correct the reported container to confirm the pickup.": ". Corrige el contenedor reportado para confirmar la recogida.",
 "1 load today": "1 carga hoy",
 "A flat tire, a breakdown or an accident? Tap it and the office is notified right away.": "¿Una llanta ponchada, una avería o un accidente? Tócalo y la oficina recibe el aviso de inmediato.",
 "A one-minute tour of the app. You can leave at any time with the X.": "Un recorrido de un minuto por la app. Puedes salir en cualquier momento con la X.",
 "A quick reminder of how to use the app. If you have questions, contact the office.": "Un recordatorio rápido de cómo usar la app. Si tienes preguntas, contacta a la oficina.",
 "A required document is still missing. Tap Add to upload it. The office closes the load when it arrives.": "Todavía falta un documento obligatorio. Toca Add para subirlo. La oficina cierra la carga cuando llega.",
 "A required document, like the Signed DO / POD, has not been uploaded yet. Open the load and add it.": "Todavía no se ha subido un documento obligatorio, como el Signed DO / POD. Abre la carga y agrégalo.",
 "Accident": "Accidente",
 "Add": "Agregar",
 "Add PDF or photo": "Agregar PDF o foto",
 "Add a fuel receipt": "Agregar un recibo de diésel",
 "Add fuel receipt": "Agregar recibo de diésel",
 "Add missing PDF or photo": "Agregar PDF o foto faltante",
 "Add the paper for this step: the Signed DO / POD at delivery, the Empty return J1 when you return the container. Required documents can also be added later.": "Agrega el papel de este paso: el Signed DO / POD en Delivery, el Empty return J1 cuando devuelves el contenedor. Los documentos obligatorios también se pueden agregar después.",
 "Add them any time. The office closes the load when they arrive.": "Agrégalos en cualquier momento. La oficina cierra la carga cuando llegan.",
 "Align the paper inside the frame": "Alinea el papel dentro del marco",
 "Align the receipt inside the frame": "Alinea el recibo dentro del marco",
 "All your required documents received.": "Se recibieron todos tus documentos requeridos.",
 "Amount": "Monto",
 "Amount *": "Monto *",
 "App guide": "Guía de la app",
 "Appointment: {cita}": "Cita: {cita}",
 "Appointment: {v0}": "Cita: {v0}",
 "Approved": "Aprobado",
 "Arrival": "Llegada",
 "Arrival recorded": "Llegada registrada",
 "Arrival:": "Llegada:",
 "Arrival: {v0}": "Llegada: {v0}",
 "Ask for oil, fluid or anything else. The office lets you know when it is ready.": "Pide aceite, líquido o cualquier otra cosa. La oficina te avisa cuando esté listo.",
 "Ask for something you need, or report something you bought.": "Pide algo que necesites o reporta algo que compraste.",
 "Assigned container:": "Contenedor asignado:",
 "Assigned container: {numero_contenedor}": "Contenedor asignado: {numero_contenedor}",
 "At Rail Pickup, enter the Delivery ETA (date, time and time zone) before you leave. If it changes, tap Update ETA. Dispatch sees every update.": "En Rail pickup, ingresa el ETA de entrega (fecha, hora y zona horaria) antes de salir. Si cambia, toca Actualizar ETA. Dispatch ve cada actualización.",
 "At each stop, tap Record arrival when you get there. Then fill in what the screen asks for and tap the confirm button (for example, Confirm delivery and departure) to leave the stop. The next stop opens by itself.": "En cada parada, toca Registrar llegada cuando llegues. Luego completa lo que pide la pantalla y toca el botón de confirmación (por ejemplo, Confirmar Delivery y salida) para salir de la parada. La siguiente parada se abre sola.",
 "At pickup, enter the chassis number and the container number. If the container does not match the order, the app warns you before you continue.": "En pickup, ingresa el número de chasis y el número de contenedor. Si el contenedor no coincide con la orden, la app te avisa antes de continuar.",
 "At pickup, type the container and chassis numbers. If the container is not the one assigned, the app warns you.": "En pickup, escribe los números de contenedor y de chasis. Si el contenedor no es el asignado, la app te avisa.",
 "At the bottom of every screen you will find Report a problem. Use it for a tire, mechanical failure, accident or anything unexpected, with a photo if you can.": "En la parte inferior de cada pantalla encontrarás Reportar un problema. Úsalo para una llanta, falla mecánica, accidente o cualquier cosa inesperada, con una foto si puedes.",
 "At the end of your shift, tap Close my day on the Loads screen. If something is missing, it tells you what before you can close. Documents still pending are listed so you can send them later.": "Al final de tu jornada, toca Cerrar mi día en la pantalla de Cargas. Si falta algo, te dice qué es antes de que puedas cerrar. Los Documentos pendientes aparecen en una lista para que puedas enviarlos después.",
 "At the rail pickup, enter the Delivery ETA in the receiver’s local time before you leave.": "En el Rail pickup, ingresa el ETA de entrega en la hora local del receiver antes de salir.",
 "Back": "Atrás",
 "Back to loads": "Volver a cargas",
 "Back to previous step": "Volver al paso anterior",
 "Back to trip recap": "Volver al resumen del viaje",
 "Back to trip summary": "Volver al resumen del viaje",
 "Broken phone": "Teléfono dañado",
 "Cancel": "Cancelar",
 "Cancelled": "Cancelada",
 "Category": "Categoría",
 "Change password": "Cambiar contraseña",
 "Chassis and container": "Chassis y contenedor",
 "Chassis returned": "Chassis devuelto",
 "Check the document": "Revisa el documento",
 "Checking the document…": "Revisando el documento…",
 "Choose a PDF or photo": "Elige un PDF o una foto",
 "Choose a category": "Elige una categoría",
 "Choose a load": "Elige una carga",
 "Choose a location": "Elige una ubicación",
 "Choose a reason": "Elige un motivo",
 "Choose photo": "Elige una foto",
 "Choose state": "Elige un estado",
 "Choose the reason": "Elige el motivo",
 "Choose the type of problem": "Elige el tipo de problema",
 "Choose where it was left": "Elige dónde se dejó",
 "City": "Ciudad",
 "Close": "Cerrar",
 "Close my day": "Cerrar mi día",
 "Completed": "Completada",
 "Confirm and leave the step": "Confirmar y salir del paso",
 "Confirm delivery and departure": "Confirmar Delivery y salida",
 "Confirm empty return and departure": "Confirmar Return empty container y salida",
 "Confirm pickup and departure": "Confirmar Pickup y salida",
 "Confirm yard stop and departure": "Confirmar Yard stop y salida",
 "Confirm: {texto}.": "Confirma: {texto}.",
 "Container and chassis": "Contenedor y Chassis",
 "Container does not match": "El contenedor no coincide",
 "Container: {numero_contenedor}{v1}": "Contenedor: {numero_contenedor}{v1}",
 "Could not access the camera. Choose a photo from your phone.": "No se pudo acceder a la cámara. Elige una foto de tu teléfono.",
 "Current ETA: {v0}": "ETA actual: {v0}",
 "Current · Step {numero} of {total}": "Actual · Paso {numero} de {total}",
 "Customer closed": "Cliente cerrado",
 "Date": "Fecha",
 "Date *": "Fecha *",
 "Date, amount, gallons and state are required": "La fecha, el monto, los galones y el estado son obligatorios",
 "Dead battery": "Batería descargada",
 "Delivered": "Entregado",
 "Delivery ETA": "ETA de entrega",
 "Delivery ETA · receiver local time ({zonaLabel})": "ETA de entrega · hora local del receiver ({zonaLabel})",
 "Delivery ETA · required before departure": "ETA de entrega · obligatoria antes de salir",
 "Delivery ETA: {v0}": "ETA de entrega: {v0}",
 "Departure": "Salida",
 "Departure recorded": "Salida registrada",
 "Description": "Descripción",
 "Description (optional)": "Descripción (opcional)",
 "Destination address": "Dirección de destino",
 "Details (optional)": "Detalles (opcional)",
 "Document looks good": "El documento se ve bien",
 "Documents from the office": "Documentos de la oficina",
 "Documents pending": "Documentos pendientes",
 "Documents pending ({falt})": "Documentos pendientes ({falt})",
 "Done today": "Hecho hoy",
 "Driver guide": "Guía del chofer",
 "ETA updated": "ETA actualizada",
 "EXPORT": "EXPORTACIÓN",
 "Each card explains one part of the app. To see it on screen, tap “Show the app guide”.": "Cada tarjeta explica una parte de la app. Para verla en pantalla, toca “Mostrar la guía de la app”.",
 "Empty container": "Contenedor vacío",
 "Empty container returned": "Contenedor vacío devuelto",
 "Empty return J1 required": "Se requiere Empty return J1",
 "Enter Delivery ETA before departure.": "Ingresa la ETA de entrega antes de salir.",
 "Enter a description": "Escribe una descripción",
 "Enter the Delivery ETA before departure.": "Ingresa la ETA de entrega antes de salir.",
 "Enter the ETA date and time": "Escribe la fecha y hora de ETA",
 "Enter the amount": "Escribe el monto",
 "Enter the final amount": "Escribe el monto final",
 "Enter the quantity": "Escribe la cantidad",
 "Enter the reported chassis.": "Ingresa el chassis reportado.",
 "Enter the reported container.": "Ingresa el contenedor reportado.",
 "Enter the yard spot.": "Ingresa el espacio de yarda.",
 "Estimated amount": "Monto estimado",
 "Every step of this trip is done.": "Todos los pasos de este viaje están listos.",
 "Everything is in order.": "Todo está en orden.",
 "Everything you uploaded on this load. The number is how many files you added.": "Todo lo que subiste en esta carga. El número indica cuántos archivos agregaste.",
 "Expense recorded": "Gasto registrado",
 "Expense sent for approval": "Gasto enviado para aprobación",
 "Explain why you are uploading it anyway": "Explica por qué lo estás subiendo de todos modos",
 "File uploaded": "Archivo subido",
 "Files": "Archivos",
 "Files (N)": "Archivos (N)",
 "Files (N) shows the PDFs and photos you uploaded for this load, with the step and the time of each one.": "Archivos (N) muestra los PDF y las fotos que subiste para esta carga, con el paso y la hora de cada uno.",
 "Files ({length})": "Archivos ({length})",
 "Files ({misArchivosN})": "Archivos ({misArchivosN})",
 "Final amount": "Monto final",
 "Finish Trip": "Terminar viaje",
 "Finished: {v0}": "Terminada: {v0}",
 "Frame the document": "Encuadra el documento",
 "Frame the signed paper": "Encuadra el papel firmado",
 "From {hora}": "Desde {hora}",
 "Fuel": "Diésel",
 "Fuel receipt": "Recibo de diésel",
 "Fuel receipts": "Recibos de diésel",
 "Gallons *": "Galones *",
 "Go to load": "Ir a la carga",
 "Help": "Ayuda",
 "Help, this guide, change your password and sign out.": "Ayuda, esta guía, cambiar tu contraseña y cerrar sesión.",
 "I bought something": "Compré algo",
 "I can’t finish this trip": "No puedo terminar este viaje",
 "I can’t upload it": "No puedo subirlo",
 "I can’t upload it — {contenedor}": "No puedo subirlo — {contenedor}",
 "I need something": "Necesito algo",
 "IMPORT": "IMPORTACIÓN",
 "If you cannot finish, tell the office why and where you left the equipment. Dispatch gives the rest of the trip to another driver.": "Si no puedes terminar, dile a la oficina por qué y dónde dejaste el equipo. Dispatch da el resto del viaje a otro chofer.",
 "If your arrival time changes, update it. The office sees every update.": "Si cambia tu hora de llegada, actualízala. La oficina ve cada actualización.",
 "In progress · Step {numero} of {length}": "En progreso · Paso {numero} de {length}",
 "In the Fuel tab, tap Add fuel receipt, take a photo of the ticket and check the details the app filled in before saving.": "En la pestaña Diésel, toca Agregar recibo de diésel, toma una foto del recibo y revisa los datos que la app completó antes de guardar.",
 "It tells you what to do next. Tap it to go straight to that step.": "Te dice qué hacer después. Tócalo para ir directo a ese paso.",
 "It will be linked to load {numero_contenedor}.": "Se vinculará a la carga {numero_contenedor}.",
 "LEONA’S GROUP · DRIVER {nombreChofer}": "LEONA’S GROUP · CHOFER {nombreChofer}",
 "LEONA’S GROUP · DRIVER {v0}": "LEONA’S GROUP · CHOFER {v0}",
 "Language / Idioma": "Idioma / Language",
 "Later": "Después",
 "Loads": "Cargas",
 "Location not set": "Ubicación no configurada",
 "Manually corrected": "Corregido manualmente",
 "Matches assigned container": "Coincide con el contenedor asignado",
 "Mechanical failure": "Falla mecánica",
 "Mechanical problem": "Problema mecánico",
 "More": "Más",
 "My receipts (last 30 days)": "Mis recibos (últimos 30 días)",
 "My requests and expenses": "Mis pedidos y gastos",
 "My route · {nombreChofer}": "Mi ruta · {nombreChofer}",
 "NEXT STOP · DELIVERY {lugar}": "PRÓXIMA PARADA · DELIVERY {lugar}",
 "Next step": "Siguiente paso",
 "No active load: the problem will be reported without a load.": "No hay una carga activa: el problema se reportará sin una carga.",
 "No date": "Sin fecha",
 "No files uploaded yet.": "Aún no has subido archivos.",
 "No station": "Sin estación",
 "Not set": "Sin definir",
 "Note (optional)": "Nota (opcional)",
 "Now": "Ahora",
 "On your last step, tap Finish Trip. The load then shows Completed. If a required document is missing, you will see Documents pending and you can add it later from the same load.": "En tu último paso, toca Terminar viaje. La carga aparecerá como Completada. Si falta un documento obligatorio, verás Documentos pendientes y podrás agregarlo después desde esa misma carga.",
 "Open the load and read the Trip Recap: container, size, appointment and each of your stops with its address and hours. When you are ready to go, tap Start Trip.": "Abre la carga y lee el Resumen del viaje: contenedor, tamaño, cita y cada una de tus paradas con su dirección y horarios. Cuando estés listo para salir, toca Empezar viaje.",
 "Opens the Delivery Order (PDF) that the office attached.": "Abre el Delivery Order (PDF) que adjuntó la oficina.",
 "Other": "Otro",
 "Other document": "Otro documento",
 "Out of hours": "Fuera de horario",
 "Pending": "Pendiente",
 "Photo (optional)": "Foto (opcional)",
 "Price per gallon": "Precio por galón",
 "Problem reported": "Problema reportado",
 "Quantity": "Cantidad",
 "Reading the ticket…": "Leyendo el ticket…",
 "Ready to start": "Listo para empezar",
 "Reason": "Motivo",
 "Reason to upload it anyway": "Razón para subirlo de todos modos",
 "Reason: {nota}": "Motivo: {nota}",
 "Receipt photo *": "Foto del recibo *",
 "Receipt saved": "Recibo guardado",
 "Receipt sent": "Recibo enviado",
 "Receiver local time · {zonaReceiver} ({v1})": "Zona horaria del receiver · {zonaReceiver} ({v1})",
 "Record": "Registrar",
 "Record arrival": "Registrar llegada",
 "Record arrival · {nombre}": "Registrar llegada · {nombre}",
 "Record your arrival first.": "Primero registra tu llegada.",
 "Record your arrival to add files.": "Registra tu llegada para agregar archivos.",
 "Recorded": "Registrado",
 "Rejected": "Rechazado",
 "Related load": "Carga relacionada",
 "Release my steps": "Liberar mis pasos",
 "Remove photo": "Eliminar foto",
 "Report": "Reporte",
 "Report a problem": "Reportar un problema",
 "Reported as pending": "Reportado como pendiente",
 "Reported chassis": "Chassis reportado",
 "Reported chassis · required": "Chassis registrado · obligatorio",
 "Reported container": "Contenedor reportado",
 "Reported container · required": "Contenedor registrado · obligatorio",
 "Request sent": "Solicitud enviada",
 "Required documents can be added later.": "Los documentos obligatorios se pueden agregar después.",
 "Return to current step": "Volver al paso actual",
 "Review does not change completed steps.": "Revisar no cambia los pasos completados.",
 "Review · Step {numero} of {length}": "Revisar · Paso {numero} de {length}",
 "Save": "Guardar",
 "Save ETA": "Guardar ETA",
 "See the status of each one here.": "Consulta aquí el estado de cada uno.",
 "Send": "Enviar",
 "Show the app guide": "Mostrar la guía de la app",
 "Sign out": "Cerrar sesión",
 "Signed DO / POD required": "Se requiere Signed DO / POD",
 "Signed DO / POD saved": "Signed DO / POD guardado",
 "Something went wrong. Please try again.": "Algo salió mal. Inténtalo de nuevo.",
 "Start Trip": "Empezar viaje",
 "State": "Estado",
 "State *": "Estado *",
 "Station": "Estación",
 "Step {v0} of {length}": "Paso {v0} de {length}",
 "Step {v0} of {total} · {nombre}{v3}": "Paso {v0} de {total} · {nombre}{v3}",
 "Supplies": "Insumos",
 "Supplies and expenses": "Insumos y gastos",
 "Take a photo": "Toma una foto",
 "Take a photo of the fuel ticket and the app reads the details for you.": "Toma una foto del recibo de diésel y la app lee los detalles por ti.",
 "Take it again": "Tómala de nuevo",
 "Take photo": "Tomar foto",
 "Tap Add PDF or photo to take a picture or choose a file. For the signed DO / POD, align the paper inside the frame in good light. The system checks that it can be read and tells you what to fix before you save.": "Toca Agregar PDF o foto para tomar una foto o elegir un archivo. Para el Signed DO / POD, alinea el papel dentro del marco con buena luz. El sistema revisa que se pueda leer y te dice qué corregir antes de guardar.",
 "Tap More in the bottom bar and choose Change password whenever you want.": "Toca Más en la barra inferior y elige Cambiar contraseña cuando quieras.",
 "Tap it when you are ready to go. The start time is saved.": "Tócalo cuando estés listo para salir. Se guarda la hora de inicio.",
 "Tap it when you finish for the day. If a required document is missing, it tells you which one. You can upload it, or tell the office you can’t.": "Tócalo cuando termines por hoy. Si falta un documento obligatorio, te dirá cuál es. Puedes subirlo o avisarle a la oficina que no puedes.",
 "Tap it when you get there. The app saves the real time; you cannot change it.": "Tócalo cuando llegues. La app guarda la hora real; no puedes cambiarla.",
 "Tap it, take a photo of the ticket and check the details the app read before you save.": "Tócalo, toma una foto del recibo y revisa los detalles que leyó la app antes de guardar.",
 "Tap to view the trip recap": "Toca para ver el resumen del viaje",
 "The Delivery Order has not been uploaded yet.": "El Delivery Order aún no se ha subido.",
 "The container number. Blue is import and orange is export.": "El número del contenedor. Azul es Import y naranja es Export.",
 "The document could not be checked (it will be saved unchecked). You can save it anyway.": "No se pudo revisar el documento (se guardará sin revisar). Puedes guardarlo de todos modos.",
 "The load you are working on: container, customer, current step and the Delivery ETA.": "La carga en la que estás trabajando: contenedor, cliente, paso actual y ETA de entrega.",
 "The previous steps are with another driver. Your next step opens here when it is your turn.": "Los pasos anteriores están con otro chofer. Tu próximo paso se abre aquí cuando sea tu turno.",
 "The receipt photo is required": "La foto del recibo es obligatoria",
 "The receipts from the last 30 days.": "Los recibos de los últimos 30 días.",
 "The reported container does not match the assigned container. Correct it to continue.": "El contenedor reportado no coincide con el contenedor asignado. Corrígelo para continuar.",
 "The steps you already finished stay in your name. Your pending steps go back to dispatch.": "Los pasos que ya terminaste quedan a tu nombre. Tus pasos pendientes regresan a dispatch.",
 "The ticket could not be read automatically. Fill in the details by hand.": "No se pudo leer el ticket automáticamente. Completa los datos a mano.",
 "The trip will show Completed when every step is finished.": "El viaje mostrará Completada cuando todos los pasos estén terminados.",
 "This category needs approval before the expense is recorded.": "Esta categoría necesita aprobación antes de registrar el gasto.",
 "This load was cancelled. Contact dispatch.": "Esta carga fue cancelada. Contacta a dispatch.",
 "This looks like a duplicate: a receipt with the same date and amount already exists": "Esto parece un duplicado: ya existe un recibo con la misma fecha y monto",
 "This step has not started yet.": "Este paso todavía no ha comenzado.",
 "Time": "Hora",
 "Tire": "Llanta",
 "Today": "Hoy",
 "Today and Upcoming": "Hoy y Próximas",
 "Today shows the loads you work on today, and any load where you still owe a document. Upcoming shows the days ahead.": "Hoy muestra las cargas en las que trabajas hoy y cualquier carga en la que todavía debas un documento. Próximas muestra los próximos días.",
 "Today’s date and how many loads you have.": "La fecha de hoy y cuántas cargas tienes.",
 "Trip Recap": "Resumen del viaje",
 "Trip completed": "Viaje completado",
 "Trip finished": "Viaje terminado",
 "Trip recap · Driver {nombreChofer}": "Resumen del viaje · Chofer {nombreChofer}",
 "Trip started": "Viaje iniciado",
 "Try closing again": "Intenta cerrar de nuevo",
 "Type": "Tipo",
 "Unload type": "Tipo de descarga",
 "Unloading": "Descarga",
 "Unloading finished; container is empty": "Descarga terminada; el contenedor está vacío",
 "Until {hora}": "Hasta {hora}",
 "Upcoming": "Próximas",
 "Upcoming · Step {numero} of {length}": "Próximas · Paso {numero} de {length}",
 "Update ETA": "Actualizar ETA",
 "Upload a photo of the receipt. If it is not a usual expense, it waits for approval.": "Sube una foto del recibo. Si no es un gasto habitual, espera aprobación.",
 "Upload anyway": "Subir de todos modos",
 "Upload receipt": "Subir recibo",
 "Upload receipt — {categoria_nombre}": "Subir recibo — {categoria_nombre}",
 "Uploaded files": "Archivos subidos",
 "Uploaded files ({length})": "Archivos subidos ({length})",
 "Uploaded {v0}": "Subido {v0}",
 "Use Back to previous step to look at an earlier stop. Nothing you entered is lost. Tap Return to current step to continue where you were.": "Usa Volver al paso anterior para ver una parada anterior. No se pierde nada de lo que ingresaste. Toca Volver al paso actual para seguir donde estabas.",
 "Use I need something to ask for supplies, or I bought something to report a purchase. Usual expenses (oil, wiper fluid) are recorded right away with the receipt photo; any other expense waits for approval.": "Usa Necesito algo para pedir insumos, o Compré algo para reportar una compra. Los gastos habituales (aceite, líquido limpiaparabrisas) se registran enseguida con la foto del recibo; cualquier otro gasto espera aprobación.",
 "Use it if you have to stop because of a mechanical problem, out of hours, a closed customer or another reason. Choose the reason; dispatch will reassign the steps you did not finish.": "Úsalo si tienes que parar por un problema mecánico, fuera de horario, un cliente cerrado u otra razón. Elige la razón; dispatch reasignará los pasos que no terminaste.",
 "View load": "Ver carga",
 "View trip": "Ver viaje",
 "View trip recap": "Ver resumen del viaje",
 "Waiting for approval": "Esperando aprobación",
 "Waiting for previous steps": "Esperando los pasos anteriores",
 "Waiting for the first step to be ready. You will be able to start when it is your turn.": "Esperando que el primer paso esté listo. Podrás empezar cuando sea tu turno.",
 "Waiting · Driver {nombre}": "Esperando · Chofer {nombre}",
 "We could not find the edges of the paper, so the whole photo was kept. For a cleaner scan, lay the paper flat on a dark surface so it fills the frame, and take it again.": "No pudimos encontrar los bordes del papel, así que se conservó la foto completa. Para un escaneo más limpio, coloca el papel sobre una superficie oscura y plana para que llene el encuadre, y tómala de nuevo.",
 "We could not find the edges of the ticket, so the whole photo was kept. For a cleaner scan, lay the ticket flat on a dark surface so it fills the frame, and take it again.": "No pudimos encontrar los bordes del recibo, así que se conservó la foto completa. Para un escaneo más limpio, coloca el recibo sobre una superficie oscura y plana para que llene el encuadre, y tómala de nuevo.",
 "Welcome": "Bienvenido",
 "When the office assigns you a load, it appears here by itself.": "Cuando la oficina te asigna una carga, aparece aquí automáticamente.",
 "When you are done at this stop, tap it. The next step opens.": "Cuando termines en esta parada, tócala. Se abrirá el siguiente paso.",
 "Where did you leave the equipment?": "¿Dónde dejaste el equipo?",
 "Where to go, the address, the hours and the instructions for this step. Steps are done in order.": "A dónde ir, la dirección, el horario y las instrucciones de este paso. Los pasos se completan en orden.",
 "Where was it left?": "¿Dónde se dejó?",
 "Write a reason": "Escribe un motivo",
 "Written help": "Ayuda escrita",
 "Yard spot": "Espacio en la yarda",
 "Yard spot · required": "Lugar en la yarda · obligatorio",
 "You are missing:": "Te falta:",
 "You can still upload these documents:": "Todavía puedes subir estos documentos:",
 "You have 1 load you have not started.": "Tienes 1 carga que no has comenzado.",
 "You have no loads assigned for today": "No tienes cargas asignadas para hoy",
 "You have no requests or expenses yet": "Todavía no tienes pedidos ni gastos",
 "You have no upcoming loads": "No tienes próximas cargas",
 "You have not added any receipts yet": "Todavía no has agregado ningún recibo",
 "You have not uploaded any files to this load yet.": "Todavía no has subido archivos a esta carga.",
 "You have {n} loads you have not started.": "Tienes {n} cargas que no has comenzado.",
 "Your app": "Tu app",
 "Your assignment": "Tu asignación",
 "Your assignment before you start: container, size, appointment and each of your stops with its address, hours and notes. Tap a stop to see it in full.": "Tu asignación antes de empezar: contenedor, tamaño, cita y cada una de tus paradas con su dirección, horario y notas. Toca una parada para verla completa.",
 "Your current step": "Tu paso actual",
 "Your day": "Tu día",
 "Your day is closed": "Tu día está cerrado",
 "Your day is closed. Please upload these documents as soon as you can:": "Tu día está cerrado. Por favor, sube estos documentos lo antes posible:",
 "Your load": "Tu carga",
 "Your loads": "Tus cargas",
 "Your pending steps were released": "Se liberaron tus etapas pendientes",
 "Your receipts": "Tus recibos",
 "Your requests and expenses": "Tus pedidos y gastos",
 "Your steps are done": "Tus pasos están listos",
 "check digit": "dígito de control",
 "e.g. 2 gallons": "p. ej., 2 galones",
 "finished; container is empty": "terminado; el contenedor está vacío",
 "optional": "opcional",
 "processed document": "documento procesado",
 "required": "requerido",
 "returned": "devuelto",
 "{contenedor_reportado} · matches": "{contenedor_reportado} · coincide",
 "{contenedor} (does not match)": "{contenedor} (no coincide)",
 "{n} loads today": "{n} cargas hoy",
 "· Driver {nombreChofer}": "· Chofer {nombreChofer}",
 "· added by the office": "· agregado por la oficina"
};
